/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useMemo,
} from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

const CallbackContext = createContext<{
  getAttachmentUrl: (id: string) => Promise<string>;
  searchMentions?: (params: {
    query: string;
    offset: number;
    limit: number;
  }) => Promise<{
    mentions: {
      id: string;
      type: 'user' | 'unit';
      data:
        | {
            id: string;
            first_name: string;
            second_name: string;
            middle_name: string;
            logo?: string;
          }
        | { id: string; name: string };
    }[];
    total: number;
  }>;
} | null>(null);

export const useAdditionalFetchDataHelpersPluginCallback = () =>
  useContext(CallbackContext);

export const AdditionalFetchDataHelpersPlugin = ({
  getAttachmentUrl,
  searchMentions,
  children,
}: {
  getAttachmentUrl: (id: string) => Promise<string>;
  searchMentions?: (params: {
    query: string;
    offset: number;
    limit: number;
  }) => Promise<{
    mentions: {
      id: string;
      type: 'user' | 'unit';
      data:
        | {
            id: string;
            first_name: string;
            second_name: string;
            middle_name: string;
            logo?: string;
          }
        | { id: string; name: string };
    }[];
    total: number;
  }>;
  children: ReactNode;
}) => {
  const [editor] = useLexicalComposerContext();

  // Регистрируем коллбэк в редакторе
  useEffect(() => {
    // Сохраняем коллбэк в замыкании
    (editor as any)._getAttachmentUrl = getAttachmentUrl;
    (editor as any)._searchMentions = searchMentions;
  }, [editor, getAttachmentUrl, searchMentions]);

  const contentValue = useMemo(
    () => ({
      getAttachmentUrl: getAttachmentUrl,
      searchMentions: searchMentions,
    }),
    [getAttachmentUrl, searchMentions],
  );

  return (
    <CallbackContext.Provider value={contentValue}>
      {children}
    </CallbackContext.Provider>
  );
};
